import { z } from "zod";
import { CompanySchema } from "./Company";

export const PlaceFieldsSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string(),
  streetAddress: z.number(),
  streetNumber: z.number(),
  localNumber: z.string(),
  postalCode: z.string(),
  city: z.string(),
  country: z.string(),
  mainAddress: z.boolean(),
  email: z.string(),
  province: z.string(),
  community: z.string(),
  county: z.string(),
  longitude: z.number(),
  latitude: z.number(),
  coordinatesModificationDate: z.date(),
  phoneNumber: z.string(),
});
export const PartialPlaceFieldsSchema = PlaceFieldsSchema.deepPartial();

export const PlaceExtraFieldsSchema = z.object({
  company: CompanySchema,
  fullName: z.string(),
});
export const PartialPlaceExtraFieldsSchema =
  PlaceExtraFieldsSchema.deepPartial();

export const PlaceSchema = z.intersection(
  PlaceFieldsSchema,
  PlaceExtraFieldsSchema
);

export type PlaceFields = z.infer<typeof PlaceFieldsSchema>;
export type PartialPlaceFields = z.infer<typeof PartialPlaceFieldsSchema>;
export type PlaceExtraFields = z.infer<typeof PlaceExtraFieldsSchema>;
export type PartialPlaceExtraFields = z.infer<
  typeof PartialPlaceExtraFieldsSchema
>;
export type Place = z.infer<typeof PlaceSchema>;
